import { render, staticRenderFns } from "./CommunityLogin.vue?vue&type=template&id=cb4256c0&scoped=true"
import script from "./CommunityLogin.vue?vue&type=script&lang=js"
export * from "./CommunityLogin.vue?vue&type=script&lang=js"
import style0 from "./CommunityLogin.vue?vue&type=style&index=0&id=cb4256c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4256c0",
  null
  
)

export default component.exports